module.exports = require("core-js-pure/stable/symbol");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/symbol.js
// module id = 453
// module chunks = 0 1